import React from 'react';
import GenericModal from '../GenericModal';
import ProductDrillDownContent from './ProductDrillDownContent';
import { ProductDrillDownSkeleton } from '../Skeletons/ModalSkeletons';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  data: any | null;
  loading: boolean;
  error: string | null;
  selectedProductName: string;
}

const ProductDrillDownModal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  data,
  loading,
  error,
  selectedProductName
}) => {
  return (
    <GenericModal
      open={isOpen}
      onClose={onClose}
      title={`Detalhamento de Créditos de ICMS – ${selectedProductName}`}
      loading={false}
      maxWidth="lg"
      fullWidth
    >
      {loading ? (
        <ProductDrillDownSkeleton />
      ) : error ? (
        <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>
      ) : (
        data && <ProductDrillDownContent data={data} />
      )}
    </GenericModal>
  );
};

export default ProductDrillDownModal; 